import React from 'react';

import { BetManager, Bus, constants, prepareRequest } from '@atlas/core';
import { Button, Input, Label } from '@atlas/ui';

import { ERRORS_MAP } from 'common/constants';

const betBookingInitialState = {
  error: null,
  loading: false,
  result: null,
};

const betBookingReducer = (state, action) => ({
  ...state,
  ...action,
});

// BetBooking request
const readPreOrderBet = async bookingId => {
  const request = prepareRequest({
    method: 'GET',
    url: `ordering/public/bet-booking/pre-order/${bookingId}`,
  });

  return request();
};

export const usePreOrderBet = (bookingId, setSelectedBetTypeIndex) =>
  readPreOrderBet(bookingId).then(result => {
    result.bets.map(bet => {
      bet.outcomes.map(outcome =>
        BetManager.addBet({
          betGroups: outcome.outcomeInfo.betMarketGroups,
          eventId: outcome.outcomeInfo.eventId,
          marketId: outcome.outcomeInfo.marketId,
          marketTypeId: outcome.outcomeInfo.marketTypeId,
          outcomeId: outcome.outcomeId,
        }),
      );

      if (bet.betType === constants.BET_TYPE.SYSTEM && bet.winCombinationSize) {
        setSelectedBetTypeIndex(bet.winCombinationSize - 1);
      }
    });

    Bus.emit('preorder:resolved');
  });

const BetBooking = ({ setSelectedBetTypeIndex }) => {
  const [state, dispatch] = React.useReducer(betBookingReducer, betBookingInitialState);
  const [active, setActive] = React.useState(false);

  const handleButtonClick = React.useCallback(() => {
    // Reset
    dispatch({
      error: null,
      loading: true,
      result: null,
    });

    usePreOrderBet(state.bookingId, setSelectedBetTypeIndex).catch(error => {
      dispatch({
        error,
        loading: false,
      });
    });
  }, [state.bookingId, usePreOrderBet]);

  return (
    <div className="bet-checker-button bet-checker-padding">
      <Label className="title-text" message="bet_booking_title" />

      <div className="bet-booking-container">
        <div className="bet-checker__wrapper">
          <Input
            active={active}
            error={state.error}
            inputMode="decimal"
            label="bookingId"
            onBlur={() => setActive(false)}
            onChange={event => dispatch({ bookingId: event.target.value })}
            onFocus={() => setActive(true)}
            type="number"
            value={state.bookingId}
          />

          <Button
            block
            disabled={!state.bookingId || state.loading}
            label="bet_booking_book"
            loading={state.loading}
            onClick={handleButtonClick}
            size="big"
            type="primary"
          />
        </div>
        {state.error && (
          <>
            {ERRORS_MAP[state.error.code] ? (
              <Label className="bet-checker__error" message={ERRORS_MAP[state.error.code]} />
            ) : (
              <div className="bet-checker__error">{state.error?.message}</div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default BetBooking;
